import { render, staticRenderFns } from "./UiBlockChoice.vue?vue&type=template&id=4b005888&scoped=true"
import script from "./UiBlockChoice.vue?vue&type=script&lang=js"
export * from "./UiBlockChoice.vue?vue&type=script&lang=js"
import style0 from "./UiBlockChoice.vue?vue&type=style&index=0&id=4b005888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b005888",
  null
  
)

export default component.exports